import React, { useEffect, useRef } from "react";

const Checkbox = React.forwardRef(function Checkbox(
    {
        checked = false,
        indeterminate = false,
        onChange,
        disabled = false,
        className = "",
        ariaLabel,
        ...rest
    },
    forwardedRef,
) {
    const localRef = useRef(null);
    const ref = forwardedRef || localRef;

    useEffect(() => {
        if (ref && ref.current) {
            ref.current.indeterminate = !checked && indeterminate;
        }
    }, [checked, indeterminate, ref]);

    return (
        <input
            ref={ref}
            type="checkbox"
            aria-label={ariaLabel}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={`h-4 w-4 cursor-pointer rounded border-ink-300 text-brand-600 transition-colors focus:ring-2 focus:ring-brand-400 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
            {...rest}
        />
    );
});

export default Checkbox;
